import { NgModule } from '@angular/core';
import { TaxonomyTermLabelPipe } from './pipes/taxonomy-term-label.pipe';
import { TaxonomyStoreModule } from './store/taxonomy-store.module';

@NgModule({
  declarations: [TaxonomyTermLabelPipe],
  imports: [TaxonomyStoreModule],
  exports: [TaxonomyTermLabelPipe],
})
export class TaxonomyModule {}
